(function() {

  let feedback;

  function initFeedback() {
    if (feedback) return;

    feedback = document.createElement('div');
    feedback.className = 'cart-feedback';
    feedback.innerText = 'Produto adicionado ao carrinho';

    document.body.appendChild(feedback);
  }

  function showCartFeedback() {
    initFeedback();

    const cartIcon = document.querySelector('.header-actions__cart-icon');
    if (!cartIcon) return;

    const rect = cartIcon.getBoundingClientRect();

    // posição vertical
    feedback.style.top = (rect.bottom + 12) + 'px';

    // centro do ícone
    const center = rect.left + rect.width / 2;

    const toastWidth = feedback.offsetWidth;
    const margin = 16;

    let left = center - (toastWidth / 2);

    left = Math.max(margin, Math.min(window.innerWidth - toastWidth - margin, left));

    feedback.style.left = left + 'px';

    // 🔥 POSIÇÃO DA SETA (AGORA FUNCIONA)
// posição relativa da seta
let arrowPosition = center - left;

// limites internos (não deixa sair do balão)
const minArrow = 12;
const maxArrow = toastWidth - 12;

// trava dentro do toast
arrowPosition = Math.max(minArrow, Math.min(maxArrow, arrowPosition));

feedback.style.setProperty('--arrow-left', arrowPosition + 'px');

    // animação
    feedback.classList.remove('show');
    void feedback.offsetWidth;
    feedback.classList.add('show');

    clearTimeout(feedback._timeout);
    feedback._timeout = setTimeout(() => {
      feedback.classList.remove('show');
    }, 2000);
  }

  function bindClick() {
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('button[name="add"]');
      if (!btn) return;
      setTimeout(showCartFeedback, 120);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initFeedback();
    bindClick();
  });

})();